import gsap from 'gsap';

gsap.registerEffect({
    name: 'displayElt',
    defaults: {
        duration: 0.85,
    },
    extendTimeline: true,
    effect: (targets, config) => gsap.from(targets,
        {
            duration: config.duration,
            opacity: 0,
            y: 40,
            rotate: 2,
            ease: 'power4.out',
            stagger: 0.1,
            onComplete: function onComplete() {
                gsap.set(this.targets(), {
                    clearProps: 'all',
                });
            },
        }),
});

gsap.registerEffect({
    name: 'fadeOut',
    defaults: {
        duration: 0.85,
    },
    extendTimeline: true,
    effect: (targets, config) => gsap.to(targets,
        {
            duration: config.duration,
            opacity: 0,
            ease: 'power4.out',
            stagger: 0.1,
            delay: 1,
        }),
});

gsap.registerEffect({
    name: 'fadeIn',
    defaults: {
        duration: 0.85,
    },
    extendTimeline: true,
    effect: (targets, config) => gsap.from(targets,
        {
            duration: config.duration,
            opacity: 0,
            ease: 'power4.out',
            stagger: 0.1,
        }),
});

gsap.registerEffect({
    name: 'letters',
    defaults: {
        duration: 0.85,
    },
    extendTimeline: true,
    effect: (targets, config) => gsap.to(targets,
        {
            duration: config.duration,
            y: 0,
            ease: 'power4.out',
            stagger: 0.05,
        }),
});